module.exports = __webpack_public_path__ + "img/icon-upload-image.f05b0d2a.png";